<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Transactions</h3>
            </d-col>
        </d-row>
        <div class="transactions-filter card-small">
            <transaction-date-filter @applyDateRangeFilter="onApplyDateRangeFilter" />
            <div class="d-flex align-items-center transactions-filter__additional-filters">
                <transaction-additional-filters @applyAdditionalFilter="onApplyAdditionalFilter" />
                <transaction-export :filter="filter" />
            </div>
        </div>
        <d-card
            v-if="!isLoading && transactions.length > 0"
            ref="transaction-rows"
            class="card-small transactions-group"
        >
            <transaction-row-item
                v-for="transaction in transactions"
                :key="transaction.tid"
                :transaction="transaction"
                :currency="getCurrencies(transaction.domain)"
            />
            <d-card-footer class="p-0 mt-3">
                <div class="d-flex">
                    <div class="flex-grow-1 d-flex flex-column align-items-end px-3">
                        <p class="mb-0">Subtotal:</p>
                        <p class="mb-0">Total:</p>
                    </div>
                    <div class="transactions-group__total">
                        <p class="mb-0">
                            {{ subTotal | toDec }}
                        </p>
                        <p class="mb-0">
                            {{ total | toDec }}
                        </p>
                    </div>
                </div>
                <pagination
                    v-if="!isLoading"
                    :options="paginationOptions"
                    :records="totalTransactions"
                    v-model="currentPage"
                    :per-page="itemsPerPage"
                    @paginate="paginate(currentPage)"
                />
            </d-card-footer>
        </d-card>
        <d-alert
            v-else-if="!isLoading && transactions.length === 0"
            theme="warning"
            show
        >
            No transactions found. Please try to set different filters.
        </d-alert>
        <d-card v-if="isLoading" class="d-flex flex-column align-items-center p-4">
            <h5 class="mb-4">
                Loading transactions
            </h5>
            <div
                class="spinner-border text-primary"
                role="status"
            >
                <span class="sr-only">
                    Loading...
                </span>
            </div>
        </d-card>
    </d-container>
</template>

<script>
import notification from '@/mixins/notification'
import loader from '@/mixins/loader'
import { TransactionService, WebsiteService } from '@/main'
import TransactionRowItem from '@/components/transactions/transactionRowItem.vue'
import TransactionExport from "@/components/transactions/transactionExport.vue";
import TransactionDateFilter from "@/components/transactions/transactionDateFilter.vue";
import TransactionAdditionalFilters from "@/components/transactions/transactionAdditionalFilters.vue";

export default {
    mixins: [notification, loader],

    components: {
        TransactionAdditionalFilters,
        TransactionDateFilter,
        TransactionExport,
        TransactionRowItem
    },

    data() {
        return {
            currentPage: 1,
            itemsPerPage: null,
            totalTransactions: 0,
            transactions: [],
            subTotal: 0,
            total: 0,
            isLoading: true,
            websites: [],
            paginationOptions: {
                chunk: 5,
                texts: {
                    count: 'Showing {from} to {to} of {count} transactions|{count} transactions|One transaction'
                }
            },
            filter: {
                startDate: null,
                endDate: null,
                websites: [],
                networks: [],
                statuses: [],
                visitorProfiles: [],
                disconnected: null,
            }
        }
    },

    methods: {
        async onApplyDateRangeFilter(parameters) {
            this.filter.startDate = parameters.start
            this.filter.endDate = parameters.end

            await this.loadTransactionsAndCalculateSubTotal()
        },

        async onApplyAdditionalFilter(parameters) {
            this.filter.websites = parameters.websites
            this.filter.networks = parameters.networks
            this.filter.statuses = parameters.statuses
            this.filter.visitorProfiles = parameters.visitorProfiles
            this.filter.disconnected = parameters.disconnected

            await this.loadTransactionsAndCalculateSubTotal()
        },

        async loadTransactionsAndCalculateSubTotal() {
            this.isLoading = true
            this.subTotal = 0

            const transactionsData = await TransactionService.getFilteredTransactions(
                {
                    startDate: this.filter.startDate,
                    endDate: this.filter.endDate,
                    websites: this.filter.websites,
                    networks: this.filter.networks,
                    statuses: this.filter.statuses,
                    visitorProfiles: this.filter.visitorProfiles,
                    disconnected: this.filter.disconnected
                },
                this.currentPage
            )
            const totalAmount = await TransactionService.getTotalAmount(
        {
                    startDate: this.filter.startDate,
                    endDate: this.filter.endDate,
                    websites: this.filter.websites,
                    networks: this.filter.networks,
                    statuses: this.filter.statuses,
                    visitorProfiles: this.filter.visitorProfiles,
                    disconnected: this.filter.disconnected
                },
            )
            this.total = totalAmount.amount
            transactionsData.transactions.data.forEach((transaction) => {
                this.subTotal += transaction.amount
            })
            this.transactions = await transactionsData.transactions.data
            this.totalTransactions = await transactionsData.transactions.total
            this.itemsPerPage = await transactionsData.transactions.per_page
            this.isLoading = false
        },

        paginate() {
            this.isLoading = true
            this.loadTransactionsAndCalculateSubTotal()
        },

        getCurrencies(websiteDomain) {
            const found = this.websites.find((website) => {
                return website.domain === websiteDomain
            })
            return found ? found.currency.code : 'EUR'
        },

        async getWebsites() {
            try {
                this.websites = await WebsiteService.get()
            } catch (e) {
                this.showNotification('warn', 'Oops! we have a problem', 'Oops! cant get domains')
                throw e
            }
        },
    }
}
</script>
